import { InjectionToken } from '@angular/core';
import { SortDir } from './table.util';

/** A sortable column, as the phone layout's "Sort by" lists it. */
export interface AdminSortOption {
  readonly field: string;
  /** The header's text, e.g. "Created". */
  readonly label: string;
  /** The header cell, for listing the options in column order. */
  readonly element: Element;
}

/** What a sort header needs from its table (kept separate to avoid an import cycle). */
export interface AdminTableSortHost {
  readonly sortField?: string;
  readonly sortDir: SortDir;
  sortBy(field: string): void;
  /** Sort headers list themselves for the phone layout, whose header row is hidden. */
  registerSort(option: AdminSortOption): void;
  unregisterSort(option: AdminSortOption): void;
}

export const ADMIN_TABLE = new InjectionToken<AdminTableSortHost>('ADMIN_TABLE');
